/**
 * NOVA MINE - Mining Parameters & Business Constants
 */
export const SECONDS_PER_DAY = 86400; // 24 hours * 3600 seconds
export const MS_PER_DAY = SECONDS_PER_DAY * 1000;
// Main Miner: 2,000 coins per 24 hours
export const MAIN_MINER_DAILY_RATE = 2000;
export const MAIN_MINER_RATE_PER_SECOND = MAIN_MINER_DAILY_RATE / SECONDS_PER_DAY; // ~0.023148148 coins/sec
// Auto Miner: 2,000 coins per 24 hours, unlocked after 3 eligible website-view tasks
export const AUTO_MINER_DAILY_RATE = 2000;
export const AUTO_MINER_RATE_PER_SECOND = AUTO_MINER_DAILY_RATE / SECONDS_PER_DAY; // ~0.023148148 coins/sec
export const AUTO_MINER_REQUIRED_TASKS = 3;
// Telegram Stars Miner: 10 Telegram Stars per miner, 100,000 coins per 24 hours per unit
export const STARS_MINER_COST_STARS = 10;
export const STARS_MINER_DAILY_RATE_PER_UNIT = 100000;
export const STARS_MINER_RATE_PER_SECOND_PER_UNIT = STARS_MINER_DAILY_RATE_PER_UNIT / SECONDS_PER_DAY; // ~1.157407407 coins/sec
// Referral System: 10,000 coins per eligible new referred user
export const REFERRAL_REWARD_COINS = 10000;
// Maximum accumulation buffer before claiming required (24 hours)
export const MAX_ACCUMULATION_SECONDS = 86400;
// Minimum partial claim threshold (e.g. 0.001 coins to prevent floating-point spam)
export const MIN_CLAIMABLE_THRESHOLD = 0.0001;
// Task Types
export var TaskType;
(function (TaskType) {
    TaskType["WEBSITE_VIEW"] = "website_view";
    TaskType["ADSGRAM_REWARDED"] = "adsgram_rewarded";
    TaskType["ADSGRAM_INTERSTITIAL"] = "adsgram_interstitial";
})(TaskType || (TaskType = {}));
// Miner Types
export var MinerType;
(function (MinerType) {
    MinerType["MAIN"] = "main";
    MinerType["AUTO"] = "auto";
    MinerType["STARS"] = "stars";
})(MinerType || (MinerType = {}));
// AdsGram Placement Configuration Keys
export const ADSGRAM_PLACEMENTS = {
    REWARDED: 'rewarded',
    INTERSTITIAL: 'interstitial',
};
//# sourceMappingURL=mining.js.map